





















































































/* tslint:disable */
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import uuifComponent from '@/shared/uuifComponent';
import { InfoState } from '@/core';
const cssPrefix = 'addServicesDialog';

@Component({
  components: {
    ...uuifComponent,
  },
})
export default class SandboxAddServicesDialog extends SwExtendedVue {
  /* tslint:disable */
  cssPrefix =  cssPrefix;

  @Prop({ required: true })
  addServiceType: any;

  @Prop()
  quoteID: string;

  @Watch('addServiceType')
  onValueChange(type: string) {
    if (type != '') {
      this.addServices(type);
    }
  }

  selectDis: string = '';
  selectSFDis: string = '';
  selectSNId: number = 0;
  selectSNDis: string = '';
  model: any = {
    userCount: '0',
  };
  isEnableNodeCount: any = false;
  minNodeCount:any = 0;
  maxNodeCount:any = 0;



  // get quoteID() {
  //   return this.$route.query.selectedQuoteId;
  // }

  get getSerialNumberOptions() {
    const serialNumberOptions = this.$store.getters['SnbQuotesStoreModule/getSerialNumberOptions'];
    let options = [];
    if (serialNumberOptions && serialNumberOptions.length > 0) {
      options = serialNumberOptions.map((el: any) => {
        return {
          id: el.serialNumber,
          value: el.serialNumber,
          label: `${el.serialNumber} ${el.friendlyName ? '- ' + el.friendlyName : ''}`,
        };
      });
      options.sort((a: any, b: any) => a['label'] > b['label'] ? 1 : a['label'] === b['label'] ? 0 : -1);
      options.unshift({ id: '', value: '', label: 'Select Serial Number' });
    }
    return options;
  }

  get getServiceNameOptions() {
    const serviceNameOptions = this.$store.getters['SnbQuotesStoreModule/getServiceNameOptions'];
    let options = [];
    if (serviceNameOptions && serviceNameOptions.length > 0) {
      for (let item of serviceNameOptions) {
        for (let val of item.serviceList) {
          if (val.buyable == "YES") {
            options.push({ id: val.serviceId.toString(), value: val.serviceId, label: val.serviceName });
          }
        }
      }
      options.sort((a, b) => a['label'] > b['label'] ? 1 : a['label'] === b['label'] ? 0 : -1);
      options.unshift({ id: '', value: '', label: 'Select Service Name' });
    }
    return options;
  }

  get getSkuOptions() {
    const skuOptions = this.$store.getters['SnbQuotesStoreModule/getSkuOptions'];
    let options = [];
    if (skuOptions && skuOptions.length > 0) {
      for (let item of skuOptions) {
        for (let val of item.arrbuyableoptions) {
          options.push({ id: val.ssipn, value: val.ssipn, label: val.serviceName + ' || ' + val.ssipn, 'isEnableNodeCount': val.bisdynamiccount, 'nodeCount': val.nodecount, 'minNodeCount': val.minnodecount, 'maxNodeCount': val.maxnodecount});
        }
      }
      options.sort((a, b) => a['value'] > b['value'] ? 1 : a['value'] === b['value'] ? 0 : -1);
      options.unshift({ id: '', value: '', label: 'Select SKU' });
    }
    return options;
  }

  onSerialNumberOptionSelect() {
    this.isEnableNodeCount = false;
    const payload = {
      serial: this.selectDis,
      equoteid: this.quoteID,
    }
    this.$store.dispatch('SnbQuotesStoreModule/getServiceInfo', payload).then((resp) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        this.$store.commit('SnbQuotesStoreModule/setServiceNameOptions', resp.serviceTypeList);
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    });
  }

  onServiceNameOptionSelect() {
    this.isEnableNodeCount = false;
    const payload = {
      serviceId: this.selectSFDis,
      productId: '',
      serialNumber: this.selectDis,
      ssipn: '',
      equoteid: this.quoteID,
    }
    this.$store.dispatch('SnbQuotesStoreModule/getServiceList', payload).then((resp) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        this.$store.commit('SnbQuotesStoreModule/setSkuOptions', resp.content.buyableServiceNames);
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    });
  }

  onSkuOptionSelect(ssipn: string) {
    const skuOptions = this.$store.getters['SnbQuotesStoreModule/getSkuOptions'];
    if (skuOptions && skuOptions.length > 0) {
      for (let item of skuOptions) {
        for (let mode of item.arrbuyableoptions) {
          if (mode.ssipn === ssipn) {
            this.isEnableNodeCount = mode.isEnableNodeCount;
            if (this.isEnableNodeCount) {
              this.model.userCount = mode.nodeCount;
              this.minNodeCount = mode.minNodeCount;
              this.maxNodeCount = mode.maxNodeCount;
            }
          }
        }
      }
    }
  }

  isValidUserCount(){
    if(this.isEnableNodeCount)
      return (+this.minNodeCount <= +this.model.userCount) && (+this.model.userCount <= +this.maxNodeCount);
    else
      return true;
  }

  addServices(type: String) {
    if (this.selectDis == '') {
      const message: InfoState = { infoType: 'high', infoMsg: 'Please select serial number.' };
      this.$store.commit('displayMessage', message);
      this.$emit('clearServiceType');
      return
    }
    if (this.selectSFDis == '') {
      const message: InfoState = { infoType: 'high', infoMsg: 'Please select service.' };
      this.$store.commit('displayMessage', message);
      this.$emit('clearServiceType');
      return
    }
    if (this.selectSNDis == '') {
      const message: InfoState = { infoType: 'high', infoMsg: 'Please select sku.' };
      this.$store.commit('displayMessage', message);
      this.$emit('clearServiceType');
      return
    }
    if (this.isValidUserCount()) {
      let payload = {
        "equoteId": this.quoteID,
        "serialNumber": this.selectDis,
        "ssipn": this.selectSNDis,
        "userCount": this.model.userCount
      }
      this.$store.dispatch('SnbQuotesStoreModule/addEquoteItems', payload).then((resp) => {
        this.$store.commit('stopLoading');
        if (resp.operationStatus === 'OK' && resp.msgCode === 'MSWAPP:ADDEQUOTEITEMS') {
          if (type === 'ADD') {
            this.selectDis = '';
            this.selectSFDis = '';
            this.selectSNDis = '';
          } else {
            this.$emit('closeServicesDialog');
          }
          const message: InfoState = { infoType: 'success', infoMsg: 'Added Successfully!' };
          this.$store.commit('displayMessage', message);
          this.$emit('clearServiceType');
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
          this.$emit('clearServiceType');
        }
      });
    } else {
      this.model.isUserCountValid = false;
    }
  }

  closeServicesDialog() {
    this.$emit('closeServicesDialog', 'ADD');
  }

  mounted() {
    const payload = {
      quoteID: this.quoteID,
    }
    this.$store.dispatch('SnbQuotesStoreModule/getPartnerSerialNumbers', payload).then((resp) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'OK') {
        this.$store.commit('SnbQuotesStoreModule/setSerialNumberOptions', resp.content.serialnumbers);
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    });
  }
}
